var _Defs, _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Defs, G, Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgCalendarCircled(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    id: "calendarCircled_svg__Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35"
  }, props), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)), _G || (_G = /*#__PURE__*/React.createElement(G, {
    id: "calendarCircled_svg__News_-_All",
    "data-name": "News - All"
  }, /*#__PURE__*/React.createElement(Path, {
    className: "calendarCircled_svg__cls-1",
    d: "M17.5.88c9.17 0 16.62 7.46 16.62 16.62S26.66 34.12 17.5 34.12.88 26.67.88 17.5 8.33.88 17.5.88m0-.88C7.83 0 0 7.84 0 17.5S7.83 35 17.5 35 35 27.16 35 17.5 27.17 0 17.5 0z"
  }), /*#__PURE__*/React.createElement(Path, {
    className: "calendarCircled_svg__cls-1",
    d: "M24.02 9.24h-1.74v-.87a.87.87 0 00-1.74 0v.87h-6.09v-.87a.87.87 0 00-1.74 0v.87h-1.74c-1.43 0-2.61 1.17-2.61 2.61v13.04c0 1.43 1.17 2.61 2.61 2.61h13.04c1.43 0 2.61-1.17 2.61-2.61V11.85c0-1.43-1.17-2.61-2.61-2.61zm1.74 15.65c0 .96-.78 1.74-1.74 1.74H10.98c-.96 0-1.74-.78-1.74-1.74V11.85c0-.96.78-1.74 1.74-1.74h1.74v.87a.87.87 0 001.74 0v-.87h6.09v.87a.87.87 0 001.74 0v-.87h1.74c.96 0 1.74.78 1.74 1.74v13.04z"
  }), /*#__PURE__*/React.createElement(Path, {
    className: "calendarCircled_svg__cls-1",
    d: "M10.98 13.59h2.61v2.61h-2.61zM16.2 13.59h2.61v2.61H16.2zM21.41 13.59h2.61v2.61h-2.61zM10.98 17.93h2.61v2.61h-2.61zM16.2 17.93h2.61v2.61H16.2zM21.41 17.93h2.61v2.61h-2.61zM10.98 22.28h2.61v2.61h-2.61zM16.2 22.28h2.61v2.61H16.2zM21.41 22.28h2.61v2.61h-2.61z"
  }))));
}
export default SvgCalendarCircled;